<template>
<v-flex>
    <h1 style="color: #969462 !important;">Notificações</h1>
    <div class="elevation-3">

        <div class="tableHeader">
            <v-dialog v-model="modal" persistent max-width="500px">
                <v-btn slot="activator" color="#969462" dark class="mb-2">
                    <v-icon class="buttonIconText" color="white">playlist_add</v-icon> Nova {{name}}
                </v-btn>
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                    </v-card-title>
                    <v-form ref="form" v-on:submit.prevent>
                        <v-card-text>
                            <v-container grid-list-md>
                                <v-layout wrap>
                                    <v-flex v-if="agendar" xs6 sm6 md6>
                                        <label class="label-modal">Data</label>
                                        <v-menu v-model="dataMenu" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                                            <v-text-field slot="activator" v-model="editedItem.data_agenda" :rules="defaultRules" prepend-icon="event" color="#969462" readonly></v-text-field>
                                            <v-date-picker locale="pt" :min="today" v-model="editedItem.data_agenda" color="#969462" @change="dataChange"></v-date-picker>
                                        </v-menu>
                                    </v-flex>
                                    <v-flex v-if="agendar" xs6 sm6 md6>
                                        <label class="label-modal">Hora</label>
                                        <v-menu :close-on-content-click="false" v-model="iniMenu" :nudge-right="40" lazy transition="scale-transition" offset-y full-width max-width="290px" min-width="290px">
                                            <v-text-field slot="activator" v-model="editedItem.hora_agenda" :rules="defaultRules" prepend-icon="timer" readonly color="#969462"></v-text-field>
                                            <v-time-picker v-if="iniMenu" v-model="editedItem.hora_agenda" full-width format="24hr" @change="iniMenu=false" color="#969462"></v-time-picker>
                                        </v-menu>
                                    </v-flex>

                                    <v-flex xs12 sm12 md12>
                                        <label class="label-modal">Método de envio de notificações</label>
                                        <v-radio-group v-model="metodo" @change="toSend=[]" :mandatory="true" row>
                                            <v-radio color="#969462" label="De forma individual" :value="0"></v-radio>
                                            <v-radio color="#969462" label="Por escritório" :value="1"></v-radio>
                                        </v-radio-group>
                                    </v-flex>
                                    <v-flex v-if="metodo==0" xs12 sm12 md12>
                                        <label class="label-modal">Destinatários</label>
                                        <v-select color="#969462" v-model="toSend" :items="clientes" :menu-props="{ maxHeight: '400' }" @change="changeSelect" item-text="nome" item-value="id_utilizador" multiple></v-select>
                                    </v-flex>
                                    <v-flex v-if="metodo==1" xs12 sm12 md12>
                                        <label class="label-modal">Escritórios</label>
                                        <v-select color="#969462" v-model="toSend" :items="escritorios" :menu-props="{ maxHeight: '400' }" @change="changeSelectD" item-text="nome" item-value="id_escritorio" multiple></v-select>
                                    </v-flex>
                                    <v-flex xs12 sm12 md12>
                                        <label class="label-modal">Título</label>
                                        <v-text-field color="#969462" :disabled="editedIndex>-1" :autofocus="true" counter maxlength="50" :rules="defaultRules" v-model="editedItem.titulo"></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm12 md12>
                                        <label class="label-modal">Descrição</label>
                                        <v-text-field color="#969462" :disabled="editedIndex>-1" :rules="defaultRules" counter maxlength="100" v-model="editedItem.descricao"></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="#969462" flat @click.native="close">Cancelar</v-btn>
                            <v-btn v-if="editedIndex==-1" :disabled="toSend.length == 0" color="#969462" flat @click.native="save">Guardar</v-btn>
                            <v-btn v-else color="#969462" :disabled="toSend.length == 0" flat @click.native="sendNotification">Reenviar</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-dialog>
            <v-btn @click="agendarNotificacao" color="#969462" dark class="mb-2">
                <v-icon class="buttonIconText" color="white">event</v-icon> Agendar {{name}}
            </v-btn>

            <v-text-field color="#969462" class="searchTable" v-model="search" append-icon="search" label="Pesquisa" single-line hide-details></v-text-field>
        </div>

        <v-dialog v-model="deleteM" persistent max-width="390">
            <v-card>
                <v-card-title class="headline" style="margin-left: 0px !important;">Apagar {{name}}</v-card-title>
                <v-card-text>De certeza que quer apagar este {{name}}?</v-card-text>
                <v-card-actions style="margin-top: 0px !important;">
                    <v-spacer></v-spacer>
                    <v-btn color="#969462" flat="flat" @click.native="close">Cancelar</v-btn>
                    <v-btn color="#969462" flat="flat" @click.native="save">Apagar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-data-table :headers="headers" :items="DATA" :search="search" :loading="loading" item-key="id" :disable-initial-sort="true" :rows-per-page-items='[10,25,50,{"text":"Todos","value":-1}]' rows-per-page-text="Itens por página:">
            <template slot="items" slot-scope="props">
                <td @click="editItem(props.item, true)" style="width: 15%;" class="textLeft">{{ props.item.id_notificacao }}</td>
                <td @click="editItem(props.item, true)" class="textLeft">{{ props.item.titulo }}</td>
                <td @click="editItem(props.item, true)" class="textLeft">{{ props.item.data }}</td>
                <td class="px-0 textTable textCenter">
                    <v-btn icon class="mx-0" @click="resend(props.item)">
                        <v-icon color="amber">send</v-icon>
                    </v-btn>
                    <v-btn icon class="mx-0" @click="editItem(props.item, true)">
                        <v-icon color="light-green darken-1">edit</v-icon>
                    </v-btn>
                    <v-btn icon class="mx-0" @click="editItem(props.item, false)">
                        <v-icon color="red lighten-1">delete</v-icon>
                    </v-btn>
                </td>
            </template>

            <template class="alertTable" slot="no-data">
                <v-alert :value="true" icon="warning">
                    De momento não há nada a apresentar! :(
                </v-alert>
            </template>
        </v-data-table>

    </div>
</v-flex>
</template>

<script>
import {
    mapState,
    mapGetters,
    mapActions
} from "vuex";
const cName = {
    upper: "Notificação",
    lower: "a notificação!"
};

export default {
    data: () => ({
        table: 'notificacoes',
        name: 'notificação',
        search: "",
        toSend: [],
        clientes: [],
        escritorios: [],
        modal: false,
        deleteM: false,
        loading: true,
        searchP: '',
        headers: [{
                text: "#",
                align: "left",
                sortable: true,
                value: "id_notificacao"
            },
            {
                text: "Título",
                align: "left",
                sortable: true,
                value: "titulo"
            },
            {
                text: "Data",
                align: "left",
                sortable: true,
                value: "data"
            },
            {
                text: "Ações",
                value: "id",
                sortable: false,
                align: "center"
            }
        ],
        metodo: 0,
        DATA: [],
        editedIndex: -1,
        agendar: false,
        editedItem: {
            id_notificacao: '',
            titulo: "",
            descricao: "",
            data: "",
            agendada: 0,
            hora_agenda: '',
            data_agenda: ''
        },
        defaultItem: {
            id_notificacao: '',
            titulo: "",
            descricao: "",
            data: "",
            agendada: 0,
            hora_agenda: '',
            data_agenda: ''
        },
        messages: {
            add: {
                success: cName.upper + " criada com sucesso!",
                error: "Ocorreu um erro ao criar " + cName.lower
            },
            update: {
                success: cName.upper + " alterada com sucesso!",
                error: "Ocorreu um erro ao alterar " + cName.lower
            },
            delete: {
                success: cName.upper + " eliminada com sucesso!",
                error: "Ocorreu um erro ao apagar " + cName.lower
            },
            default: {
                sucesso: "Sucesso",
                error: "Ocorreu um erro!"
            }
        },
        defaultRules: null,
        today: '',
        dataMenu: false,
        iniMenu: false,
    }),

    computed: {
        ...mapGetters({
            getAll: 'notificacoes/getAll',
            getClientes: 'utilizadores/getClientes',
            getEscritorios: 'escritorios/getAll'
        }),
        formTitle() {
            return this.editedIndex === -1 ? "Nova " + this.name : "Editar " + this.name;
        }
    },

    watch: {
        modal(val) {
            val || this.close()
        },
        deleteM(val) {
            val || this.close()
        },
        getAll(val) {
            this.initialize()
        },
        getClientes(val) {
            this.intiArrays();
        },
        getEscritorios(val) {
            this.intiArrays();
        }
    },

    created() {
        this.defaultRules = [v => !!v || this.$requiredField + ''];

        this.today = this.$moment().format("YYYY-MM-DD");

        setTimeout(() => {
            this.intiArrays()
        }, 1000);
        this.initialize();
    },
    mounted() {

    },
    methods: {
        dataChange() {
            this.dataMenu = false;
            this.iniMenu = true;
        },
        intiArrays() {
            this.clientes = [].concat(this.getClientes);
            this.clientes.unshift({
                id_utilizador: 0,
                nome: 'Todos'
            });

            this.escritorios = [].concat(this.getEscritorios);
            this.escritorios.unshift({
                id_escritorio: 0,
                nome: 'Todos'
            });
        },

        toast(type, message) {
            if (type == "success") {
                return iziToast.show({
                    title: "SUCESSO",
                    color: "green",
                    timeout: this.$toastTimeout,
                    message: message,
                    position: this.$toastPosition
                });
            } else {
                return iziToast.show({
                    title: "AVISO",
                    color: "red",
                    timeout: this.$toastTimeout,
                    message: message,
                    position: this.$toastPosition
                });
            }
        },

        changeSelect() {
            if (this.toSend.findIndex((el) => {
                    return el == 0
                }) > -1) this.toSend = this.clientes.map((el) => {
                return el.id_utilizador
            });
        },

        changeSelectD() {
            if (this.toSend.findIndex((el) => {
                    return el == 0
                }) > -1) this.toSend = this.escritorios.map((el) => {
                return el.id_escritorio
            });
        },

        initialize() {
            this.loading = true;
            this.DATA = this.getAll;
            this.loading = false;
        },

        agendarNotificacao() {
            this.agendar = true;
            this.modal = true;
        },

        editItem(item, dialog) {
            this.editedIndex = this.DATA.indexOf(item);
            this.editedItem = Object.assign({}, item);

            if (dialog) this.modal = true;
            else this.deleteM = true;
        },

        resend(item) {
            this.editedIndex = this.DATA.indexOf(item);
            this.editedItem = Object.assign({}, item);

            this.modal = true;
        },

        delete() {
            if (!this.editedItem.id_notificacao) return;

            this.$store
                .dispatch(this.table + "/delete", {
                    id: this.editedItem.id_notificacao
                })
                .then((res) => {
                    if (res) {
                        this.toast('success', this.messages.delete.success);
                        this.initialize();
                    } else this.toast('error', this.messages.delete.error);

                    this.deleteM = false;
                });
        },

        close() {
            this.modal = this.deleteM = false;
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
                this.toSend = [];
                this.agendar = false;
                this.$refs.form.reset();

                setTimeout(() => {
                    this.metodo = 0;
                }, 50);
            }, 110);
        },

        sendNotification() {
            if (this.toSend.length == 0) return;

            if (this.toSend.findIndex((el) => {
                    return el == 0
                }) > -1) {
                this.$store.dispatch('notificacoes/sendToAll', {
                    titulo: this.editedItem.titulo.toUpperCase(),
                    descricao: this.editedItem.descricao
                }).then((res) => {
                    if (res) this.toast('success', 'Notificação enviada com sucesso.');
                    else this.toast('error', 'Ocorreu um erro ao enviar a notificação.');
                });
            } else {
                this.$store.dispatch('notificacoes/sendToUsers', {
                    titulo: this.editedItem.titulo.toUpperCase(),
                    descricao: this.editedItem.descricao,
                    clientes: this.metodo == 0 ? this.toSend.filter((el) => {
                        return el > 0
                    }) : this.clientes.map((el) => {
                        if (this.toSend.findIndex((e) => {
                                return e == el.id_escritorio
                            }) > -1) return el.id_utilizador
                    }).filter((el) => {
                        return typeof el != 'undefined'
                    })
                }).then((res) => {
                    if (res) this.toast('success', 'Notificação enviada com sucesso.');
                    else this.toast('error', 'Ocorreu um erro ao enviar a notificação.');
                });
            }

            this.modal = false;
        },

        save() {
            if (this.deleteM) {
                this.delete();
                return;
            }
            if (!this.$refs.form.validate()) return;

            if (this.toSend.length == 0) return;

            if (this.editedIndex == -1) {
                this.$store
                    .dispatch(this.table + "/insert", {
                        titulo: this.editedItem.titulo,
                        descricao: this.editedItem.descricao,
                        agendada: this.agendar ? 1 : 0,
                        data_agendada: this.agendar ? this.editedItem.data_agenda + ' ' + this.editedItem.hora_agenda : '-',
                        clientes: this.metodo == 0 ? this.toSend.filter((el) => {
                            return el > 0
                        }) : this.clientes.map((el) => {
                            if (this.toSend.findIndex((e) => {
                                    return e == el.id_escritorio
                                }) > -1) return el.id_utilizador
                        }).filter((el) => {
                            return typeof el != 'undefined'
                        })
                    })
                    .then((res) => {
                        if (res) {
                            if(!this.agendar) this.sendNotification();
                            this.initialize();
                        } else this.toast('error', this.messages.add.error);

                        this.modal = false;
                    });
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/tables/Table_Notificacoes.vue